const DEFAULT_OPACITY = 0.025

/** Step size for opacity adjustments (shared with path UI). */
export const change_by = 0.08
const OPACITY_PRECISION = 10000
const MAX_OPACITY = 0.9

export const change = (opacity = DEFAULT_OPACITY, resolution = change_by) => {
  let value = typeof opacity === 'string' ? parseFloat(opacity) : opacity

  value = value * OPACITY_PRECISION
  value = Math.round(value)
  value = value / OPACITY_PRECISION

  value += resolution

  if (value > 1) value = MAX_OPACITY
  else if (value < 0) value = DEFAULT_OPACITY

  return value
}
